import {AssistantEvenCompactModel} from "../assistants";
import {ListModel} from "../common";

import {InformationExtractorActionQuestion} from "@/api/services";
import {BaseAction} from "@/types/api";

export interface InformationExtractorRecordModel extends BaseAction {
  title: string;
  description: string;
  assistants: AssistantEvenCompactModel[];
  question: InformationExtractorActionQuestion;
}

export type InformationExtractorListModel =
  ListModel<InformationExtractorRecordModel>;

export enum InformationExtractorQuestionTypes {
  YES_NO = "yesno",
  CHOICE = "choice",
  OPEN = "open",
}

export enum InformationExtractorIdentifierTypes {
  USER_NAME = "user_name",
  USER_EMAIL = "user_email",
  USER_COMPANY = "user_company",
  USER_ADDRESS = "user_address",
  DND = "dnd",
  CALL_OUTCOME = "call_outcome",
  CALL_TRANSFORMED_TO = "call_transformed_to",
  REASON_FOR_CALL = "reason_for_call",
  ISSUE_DESCRIPTION = "issue_description",
  USER_INTEREST_LEVEL = "user_interest_level",
  CALLBACK_REQUESTED = "callback_requested",
  OBJECTION_HANDLING = "objection_handling",
  BUDGET_RANGE = "budget_range",
  LEAD_QUALIFICATION = "lead_qualification",
  REASON_NOT_BOOKED = "reason_not_booked",
}

export type InformationExtractorTemplateRecordModel = {
  identifier: string;
  text: string;
  examples?: string[];
  choices?: string[];
  type: InformationExtractorQuestionTypes;
};

export type InformationExtractorTemplateListModel =
  ListModel<InformationExtractorTemplateRecordModel>;

export type InformationExtractorCreateModel = {
  workspaceId: string;
  question: InformationExtractorActionQuestion;
  name: string;
};

export type InformationExtractorUpdateModel =
  InformationExtractorCreateModel & {
    id: string;
  };
